const u = (id, w = 1600) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&q=80&w=${w}`;

export const IMG = {
  hero: "https://images.pexels.com/photos/36220947/pexels-photo-36220947.jpeg?auto=compress&cs=tinysrgb&w=1920",
  chauffeur: "/images/fleet-e-class.jpg",
  fleetVClass: "/images/fleet-v-class.jpg",
  fleetSClass: "/images/fleet-s-class.jpg",
  lifestyle: u("photo-1551882547-ff40c63fe5fa", 1400),
  dining: u("photo-1414235077428-338989a2e8c0", 900),
  jet: u("photo-1540962351504-03099e0a754b", 900),
  gala: u("photo-1519167758481-83f550bb49b3", 900),
  hotelRoom: u("photo-1582719508461-905c673771fd", 1600),
  jetInterior: u("photo-1569629743817-70d8db6c323b", 1200),
  theatre: u("photo-1507924538820-ede94a04019d", 1600),
  f1: u("photo-1517672651691-24622a91b550", 900),
  tennis: u("photo-1595435934249-5df7ed86e1c0", 900),
  concert: u("photo-1470229722913-7c0e2dbbafd3", 900),
  galaTables: u("photo-1464366400600-7168b8af9bc3", 1600),
  cannes: u("photo-1469334031218-e382a71b716b", 900),
  celebration: u("photo-1492684223066-81342ee5ff30", 900),
  yacht: u("photo-1569263979104-865ab7cd8d13", 900),
  resort: u("photo-1571896349842-33c89424de2d", 1600),
  wineCellar: u("photo-1510812431401-41d2bd2722f3", 1200),
  skyline: u("photo-1514565131-fce0801e5785", 1600),
  villa: u("photo-1613490493576-7fde63acd811", 1200),
  pool: u("photo-1571896349842-33c89424de2d", 1200),
  wine: u("photo-1506377247377-2a5b3b417ebb", 900),
  watch: u("photo-1523170335258-f5ed11844a49", 900),
  city: u("photo-1477959858617-67f85cf4f1df", 1400),
  bar: u("photo-1514933651103-005eec06c04b", 1200),
  monteCarlo:
    "https://images.pexels.com/photos/36220947/pexels-photo-36220947.jpeg?auto=compress&cs=tinysrgb&w=1400",
  jetWing:
    "https://images.pexels.com/photos/34779895/pexels-photo-34779895.jpeg?auto=compress&cs=tinysrgb&w=1200",
};
